import { render, staticRenderFns } from "./ModalAllNotifications.vue?vue&type=template&id=556db4b9&scoped=true&"
import script from "./ModalAllNotifications.vue?vue&type=script&lang=js&"
export * from "./ModalAllNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ModalAllNotifications.vue?vue&type=style&index=0&id=556db4b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556db4b9",
  null
  
)

export default component.exports